<template>
<div>
  
  <div id="mydiv" style="text-align: right;right:15px;
  z-index: 3;opacity:1;max-width:85px;" :style="'top:' + topPosition + '%'">
  <div id="mydivheader"><b-dropdown id="dropdown-right" text="User Guides "
   style="background: transparent;font-weight: bolder;margin: 0px 10px !important;"  
   :variant="variant" no-caret right >
   <template #button-content>
     <div style="background: #f3a113;
      box-shadow: inset -5px -5px 20px #ae4d0a !important;
      border-radius: 12px 0px 12px 0px !important;
     cursor:pointer;padding: 4px 0px 4px 7px;line-height: 12px;"
     class="guideflap blink">
     <span style="display: inline-block;
    font-size: 12px;text-shadow: 2px 1px 4px #932905;color:#fff;
    text-align: left;vertical-align: sub;padding:1px 0px;">User<br>Guides</span>
        <span style="display: inline-block;
    font-size: 20px;padding-left: 4px;margin-right: 3px;">&#128209;</span>
<span class="sr-only">User Guides</span>
</div>
    </template>
    <b-dropdown-text v-show="videoGuides.length > 0" style="font-size: 11px;font-weight: bold;white-space: nowrap;">User Guides of this page:</b-dropdown-text>
    <b-dropdown-divider v-show="videoGuides.length > 0"></b-dropdown-divider>
    <b-dropdown-item-button v-for="v in videoGuides" v-bind:key="v" v-show="videoGuides.length > 0">
      <a target="blank" :href="v.url">&#x2630; {{v.displayName}}</a></b-dropdown-item-button>
      <b-dropdown-item-button v-if="videoGuides.length==0">No guides available for this page!</b-dropdown-item-button> 
      </b-dropdown></div>
</div>
</div>
</template>

<script> 
import loadingSpinner from "../widgets/LoadingSpinner";
import { DashboardService } from "../services/DashboardService.js";
const DashboardServices = new DashboardService();

export default {
  components: { 
    "w-loadingSpinner": loadingSpinner,
  },
  props: ["variant","partnerNumber"],
  data() {
    return {
      loading: false,
      videoGuides:[],
      topPosition:34,
    };
  },
  mounted(){
    
//Make the DIV element draggagle:
dragElement(document.getElementById("mydiv"));

function dragElement(elmnt) {
  var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
  if (document.getElementById(elmnt.id + "header")) {
    /* if present, the header is where you move the DIV from:*/
    document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
  } else {
    /* otherwise, move the DIV from anywhere inside the DIV:*/
    elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    // get the mouse cursor position at startup:
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    // set the element's new position:
    elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
    elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
  }

  function closeDragElement() {
    /* stop moving when mouse button is released:*/
    document.onmouseup = null;
    document.onmousemove = null;
  }
}
  },
  created() {var self = this
    var pagename = window.location.pathname.split('/')[2]
    DashboardServices.getVideoGuides(pagename).then(resp => {
        this.videoGuides = resp.response;
        this.topPosition = resp.response.length > 0 ? this.videoGuides[0].topPosition : 34
        self.$root.$emit('toppos', self.topPosition )
      });

      
    EventBus.$on('updatepageguides',function(){     
      self.getVideoGuides()
    });
  },
  methods: {
    getVideoGuides(){
      var self = this
      var pagename = window.location.pathname.split('/')[2]
      DashboardServices.getVideoGuides(pagename).then(resp => {
        this.videoGuides = resp.response;
        this.topPosition = resp.response.length > 0 ? this.videoGuides[0].topPosition : 34
        self.$root.$emit('toppos', self.topPosition )
      });
    }
  }
};
</script>

<style>
.guideflap:hover{
      padding-left: 10px !important;
}

#mydiv {
  position: absolute;
  z-index: 9;
  text-align: center;
}
#mydivheader:hover {
  right:15px;
}

.blink {
        animation: blinker 0.5s;
        animation-iteration-count: 20;
    }
      
    @keyframes blinker {
        from { background: #f3a113; }
        50% {  background: #ffee00; }
        to { background: #f3a113; }
    }
</style>
